export { MainTemplate } from './main-template'
